


































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import CouponSelect from '@/components/coupon-select/index.vue'
import Api from '@/api/mall/mallConfig/index'
import PicModal from '@/components/upload/picModal.vue'
@Component({
  components: {
    CouponSelect,
    PicModal,
  },
})
export default class MemberInvitation extends Vue {
  formData = {
    Coupons: [],
    BackgroundImage: '',
    QrCodeImage: '',
    AdImage: '',
    Invitation: 1,
  }
  formRule: any = {
    Invitation:[
      {
        require: true,
        validator: this.validateInvitation,
        trigger: 'blur'
      }
    ]
  }
  validateInvitation(rule,value,callback){
    if(!value){
      return callback(new Error('请输入人数'))
    } else if(value.toString().includes('.')){
      return callback(new Error('人数不能为小数'))
    } else{
      callback()
    }
  }
  get rewardColumns() {
    return [
      {
        title: '优惠券名称',
        key: 'name',
      },
      {
        title: '优惠券类型',
        key: 'couponTypeDisplayName',
      },
      {
        title: '面额/折扣',
        key: 'discountValue',
      },
      {
        title: '赠送数量',
        key: 'quantity',
        render: (h, params) => {
          return h('InputNumber', {
            props: {
              value: this.formData.Coupons[params.index] ? this.formData.Coupons[params.index].quantity : 0,
              min: 0,
            },
            on: {
              'on-change': (event: number) => {
                this.formData.Coupons[params.index].quantity = event
              },
            },
          })
        },
      },
      {
        title: '操作',
        key: 'action',
        slot: 'action',
      },
    ]
  }
  get rewardCouponIds() {
    let arr =
      this.formData.Coupons && this.formData.Coupons.length
        ? this.formData.Coupons.map((x) => x.id)
        : []
    return arr
  }
  mounted() {
    this.loadData()
  }
  loadData() {
    Api.getMallConfig('MemberInviteConfig').then((res) => {
      if (res.data) {
        if (!res.data.Coupons) {
          res.data.Coupons = []
        }
        this.formData = res.data
      }
    })
  }
  save() {
    (this.$refs['formValidate'] as any).validate((valid) => {
      if (valid) {
        Api.updateMallConfig('MemberInviteConfig', '会员邀请入会', this.formData).then((res) => {
          this.$Message.success('保存成功')
        })
      } else {
        this.$Message.error('请输入正确的人数')
      }
    })
  }
  deleteItems(index, type) {
    this.formData.Coupons.splice(index, 1)
  }
  onCouponChange(e, type) {
    if (!this.formData.Coupons) {
      this.formData.Coupons = []
    }
    console.log('执行了这里', e, type, this.formData.Coupons)
    this.formData.Coupons = this.formData.Coupons.concat(
      e.map((t) => {
        return {
          id: t.id,
          code: t.code,
          name: t.name,
          couponTypeDisplayName: t.couponTypeDisplayName,
          discountValue: t.discountValue,
          quantity: 0,
        }
      })
    )
  }
  picChange(e, type) {
    console.log(e);
    switch (type) {
      case 'background':
        this.formData.BackgroundImage = e[0].url
        break;
      case 'qrcode':
        this.formData.QrCodeImage = e[0].url
        break;
      case 'ad':
        this.formData.AdImage = e[0].url
        break;
    }
  }
}
